import type { ReactNode } from 'react';
import { useAuthGuard } from '@core/auth/hooks/useAuthGuard';
import { Role, type Permission } from '@core/auth';

interface ProtectedRouteProps {
  children: ReactNode;
  requiredRoles?: Role[];
  requiredPermissions?: Permission[];
  requireVerified?: boolean;
}

export function ProtectedRoute({
  children,
  requiredRoles,
  requiredPermissions,
  requireVerified,
}: ProtectedRouteProps) {
  const { isAuthorized, isLoading } = useAuthGuard({
    requiredRoles,
    requiredPermissions,
    requireVerified,
  });

  if (isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <div className="h-8 w-8 animate-spin rounded-full border-4 border-primary border-t-transparent" />
      </div>
    );
  }

  if (!isAuthorized) {
    return null;
  }

  return <>{children}</>;
}
